import React from 'react';

import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';


const confirmAction = (props) => {
  return (
    <Dialog
      hidden={ false }
      onDismiss={ props.cancel }
      dialogContentProps={{
        type: DialogType.normal,
        title: 'Are you sure?',
        subText: 'This action cannot be reversed, Click cancel if you don\'t wish to proceed.'
      }}
      modalProps={{
        isBlocking: true,
      }}
    >
      <DialogFooter>
        <PrimaryButton onClick={ () => props.confirm() } text="Continue" />
        <DefaultButton onClick={ () => props.cancel() } text="Cancel" />
      </DialogFooter>
    </Dialog>
  )
};

export default confirmAction;


// WEBPACK FOOTER //
// ./src/components/confirmAction.js